module.exports = {
    digitalPayCreditCardFields: {
        cardNumber: 'card',
        month: 'month',
        year: 'year',
        cvv: 'cvv',
    },
};



// WEBPACK FOOTER //
// ./src/common/settings/groups/digitalpay-creditcard-fields.js